import { IMenuItem } from 'types';

export const PATH_ACCOUNT = `/account`;

export enum pathsAccount {
  Application = '/loans',
  LoanHistory = '/history',
  PersonalInformation = '/extra',
}

export const PATH_ACC_APPLICATION = `${PATH_ACCOUNT}${pathsAccount.Application}`;
export const PATH_ACC_LOAN_HISTORY = `${PATH_ACCOUNT}${pathsAccount.LoanHistory}`;
export const PATH_ACC_PERSONAL_INFORMATION = `${PATH_ACCOUNT}${pathsAccount.PersonalInformation}`;

export const LIST_MENU_ACCOUNT: IMenuItem[] = [
  { label: 'account_header_link_application', path: PATH_ACC_APPLICATION },
  { label: 'account_header_link_credit_history', path: PATH_ACC_LOAN_HISTORY },
  { label: 'account_header_link_personal_information', path: PATH_ACC_PERSONAL_INFORMATION },
];
